import React, { useState, useEffect } from "react";
import "./index.less";
import { Button, message } from "antd";
import { useNavigate } from "react-router-dom";
import note from '@/assets/note.png'
import AliyunOSSUploadImg from "@/components/AliyunOssComponent/index2";
import Config from "@/config/config";
import { request } from "@/utils";


export default function DiningCompleted() {
    const navigate = useNavigate();
    const [imgUrl, setImgUrl] = useState([])
    const queryParams = new URLSearchParams(window.location.search);
    useEffect(() => {
        getRefoundTip()
    }, [])
    const imgUploadResult = (newFileList) => {
        console.log(newFileList, 'ppp')
        setImgUrl([...newFileList]);
    }
    const sureComplete = () => {
        if (imgUrl.length < 1) {
            message.error("请上传就餐凭证");
            return;
        }
        console.log(imgUrl, 'imgUrl')
        let imgList = []
        imgUrl.forEach(v => {
            imgList.push(v.url)
        })
        let requestUrl = queryParams.get('type') == 1 ? `restaurant/reservation_order_finish` : `goodseat_order/finish`
        request.post(requestUrl, { id: queryParams.get('id'), transaction_slip: imgList }).then(r => {
            message.success('已就餐成功')
            setTimeout(() => {
                navigate(-1)
            }, 500)
        })
    }
    const [tips, setTips] = useState({})
    const getRefoundTip = async () => {
        const response = await request.get('agreement/detail?sub_type=3&type=1');
        setTips(response.data || {})
    }
    return (
        <div className="completed-background">
            <div className="completed-content">
                <Button type="cancel" style={{ with: "74px", height: "32px", color: "#999999", borderRadius: "4px" }}
                    onClick={() => navigate(-1)}>
                    返回
                </Button>
                <div className="completed-note">
                    <img src={note} alt="" />
                    <span>请上传就餐凭证(就餐支付小票等)以确认就餐完成，凭证审核通过后将退还押金。</span>
                </div>
                <div className="completed-upload">
                    <div className="completed-title">上传凭证</div>
                    <AliyunOSSUploadImg onChange={imgUploadResult} type="info" />
                    <div className="completed-tip"><span>*</span>请确保小票清晰可见，我们将在1-3个工作日内处理押金退款</div>
                </div>
                <div className="refound">
                    <div className="refound-title">退款说明：</div>
                    <div className="refound-desc" dangerouslySetInnerHTML={{ __html: tips.content }}></div>

                </div>
            </div>
            <div className="completed-footer">
                <div className="completed-footer-content">
                    <div className="sure-btn" onClick={sureComplete}>确定</div>
                </div>
            </div>
        </div>
    );

}

